import { JetView } from 'webix-jet';
import { devConfig, profile } from 'config/config';

/**
 * Class representing the view for filtering promotional codes.
 * @extends JetView
 */
export default class FilterPromotionalCodesView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text',
                            name: 'Id',
                            type: 'number',
                            label: _("<span class='icon-id'></span>ID"), // ID label
                            labelPosition: 'top',
                            placeholder: _('ID'), // Placeholder for ID input
                        },
                        {
                            view: 'text',
                            name: 'UserId',
                            type: 'number',
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Usuario'), // User ID label
                            hidden: !devConfig.getPermAction('filterByUser', 'Add'), // Conditional visibility based on permissions
                            css: 'prm-filterByUser',
                            labelPosition: 'top',
                            placeholder: _('ID Usuario'), // Placeholder for User ID input
                        },
                        {
                            view: 'text',
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha de Creación'), // Creation date label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for datepicker
                        },
                        {
                            view: 'datepicker',
                            name: 'Date',
                            id: 'Date',
                            stringResult: true,
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Date label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for date input
                            value: moment().format('YYYY-MM-DD'), // Default date value
                            format: '%d %M %Y', // Date format
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(), // Maximum selectable date
                                },
                            },
                        },
                        {
                            view: 'richselect',
                            name: 'TypeBalance',
                            label: _('Tipo saldo'), // Balance type label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for balance type selection
                            value: '',
                            options: [
                                { id: '', value: _('Todos') }, // Option for all types
                                { id: '0', value: _('Saldo recargas') }, // Option for recharge balance
                                { id: '1', value: _('Saldo retiros') }, // Option for withdrawal balance
                            ],
                        },
                    ],
                },
            ],
        };

        const upper_section = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 290 : 0, // Conditional height based on screen width
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section containing filters
                },
            ],
        };

        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { gravity: 1, id: 'grav' }, // Placeholder for responsive layout
                        {
                            view: 'button',
                            value: _('Añadir Ajuste'), // Button label for adding adjustment
                            type: 'form',
                            width: screen == 'small' ? 0 : 200, // Conditional width based on screen size
                            minWidth: 200,
                            hidden: !devConfig.getPermAction('balanceAdjustmentsAdd', 'Add'), // Conditional visibility based on permissions
                            css: 'prm-balanceAdjustmentsAdd',
                            click: () => {
                                this.app.callEvent('addAdjustment:button', [{}]); // Event call for adding adjustment
                            },
                        },
                        {
                            view: 'button',
                            value: _('Limpiar'), // Button label for clearing filters
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear(); // Clear the form inputs
                            },
                        },
                        {
                            view: 'button',
                            value: _('Consultar'), // Button label for consulting
                            hotkey: 'enter', // Hotkey for the button
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                if (profile.typeDate !== 2) {
                                    delete filterdata['Date']; // Remove Date if typeDate is not 2
                                } else {
                                    if (true) {
                                        delete filterdata['Datepicker']; // Remove Datepicker if typeDate is 2
                                    }
                                }
                                this.app.callEvent('balanceAdjustments:filter', [filterdata]); // Event call for filtering
                                $$('b5').collapse(); // Collapse the filter section
                                $$('a5').scrollTo(100, 0); // Scroll to a specific position
                            },
                        },
                    ],
                },
            ],
        };

        const accordion_section2 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: false,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for the filters section
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Include upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };

        return {
            view: 'form',
            type: 'clean',
            rows: [accordion_section2], // Main layout of the form
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav').hide(); // Hide element if screen width is less than 500
            }
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Hide Date input if typeDate is not 2
                $$('Datepicker').show(); // Show Datepicker
            } else {
                if (true) {
                    $$('Date').show(); // Show Date input if typeDate is 2
                    $$('Datepicker').hide(); // Hide Datepicker
                }
            }
        });

        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal based on language
        });
    }
}

// FILE DOCUMENTED
